// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2BAq8","options":"AnswerScale_options__2UzG7","selected":"AnswerScale_selected__NSrmX"};